export enum ConsumptionSummaryUnitEnum {
    BYTE = "BYTE",
    BYTES = "BYTES",
    SECOND = "SECOND",
    SECONDS = "SECONDS",
    CENT = "CENT",
    CENTS = "CENTS",
    GB = "GB",
    SMS = "SMS",
    MINUTES = "MINUTES"
}